// =========================================
// Backyard Gallery
// Centred intro + full-bleed image slider. Figma 329:6652 / 329:8778
// One centre image shown full with the prev/next images peeking either side,
// at every breakpoint. Looped, draggable, with prev/next arrows.
// Raise slidesPerView to reveal more of the side images (1.5 ≈ a small peek,
// 2 ≈ half of each neighbour visible).
// Swiper comes from the shared swiper-core bundle (window.Swiper).
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const Swiper = window.Swiper;
    const { Navigation, Pagination } = window.SwiperModules || {};
    if (!Swiper) return;

    const galleries = document.querySelectorAll('[data-gallery-slider]');
    if (!galleries.length) return;

    galleries.forEach(function (wrap) {
        // One Swiper per block, with controls scoped to this wrapper so multiple
        // galleries on a page don't hijack each other's dots/arrows.
        const sliderEl = wrap.querySelector('.backyard-gallery__slider');
        if (!sliderEl) return;

        // Loop mode needs comfortably more slides than fit in view (up to 2.4
        // per view plus the side peeks). With only a few images the loop can't
        // fill both peeks and leaves an empty gap on load (Swiper even warns
        // "number of slides is not enough for loop mode"). Clone the set until
        // there are enough so the loop is seamless regardless of image count.
        const track = sliderEl.querySelector('.swiper-wrapper');
        const MIN_SLIDES = 8;
        const originals = Array.prototype.slice.call(track.children);
        if (originals.length && originals.length < MIN_SLIDES) {
            let i = 0;
            while (track.children.length < MIN_SLIDES) {
                track.appendChild(originals[i % originals.length].cloneNode(true));
                i++;
            }
        }

        const swiper = new Swiper(sliderEl, {
            modules: [Navigation, Pagination].filter(Boolean),
            loop: true,
            speed: 600,
            grabCursor: true,
            // Re-measure when slide sizes/content change — a full-bleed,
            // centred slider is otherwise computed before lazy images load
            // and lands off-centre on first paint.
            observer: true,
            observeParents: true,
            centeredSlides: true,
            slidesPerView: 1.5,
            spaceBetween: 16,
            pagination: {
                el: wrap.querySelector('[data-gallery-pagination]'),
                clickable: true,
            },
            navigation: {
                nextEl: wrap.querySelector('[data-gallery-next]'),
                prevEl: wrap.querySelector('[data-gallery-prev]'),
            },
            breakpoints: {
                // Tablet — smaller centre image, more of the neighbours showing.
                768: {
                    slidesPerView: 1.8,
                    spaceBetween: 24,
                },
                // Desktop — matches Figma 329:6656: centre image ~40% of the
                // viewport (747px @ 1920) with the two neighbours peeking ~73%,
                // 32px gutter. Higher slidesPerView = smaller centre image.
                992: {
                    slidesPerView: 2.4,
                    spaceBetween: 32,
                },
            },
        });

        // loop + centeredSlides mis-computes the initial translate — it lands one
        // slide off-centre until the first interaction. update() alone only fixes
        // sizes, not the loop offset, so re-run the loop positioning (what a
        // prev/next click does) after layout settles and again on full load.
        function recentre() {
            swiper.update();
            swiper.slideToLoop(swiper.realIndex, 0, false);
        }

        requestAnimationFrame(recentre);
        window.addEventListener('load', recentre);

        sliderEl.querySelectorAll('img').forEach(function (img) {
            if (!img.complete) {
                img.addEventListener('load', recentre, { once: true });
            }
        });
    });
});
